module.exports = __webpack_public_path__ + "img/welcomes-icon-android.54486829.png";